import MuiSlider, { SliderProps as MuiSliderProps } from '@mui/material/Slider';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface SliderProps extends MuiSliderProps {}

export const Slider: React.FC<SliderProps> = ({ ...props }) => {
  return <MuiSlider {...props} />;
};
